<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-10-10 14:30:13
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-25 14:25:58
-->
<template>
	<div class="chooseCooPartner">
		<!-- 合作对象组件 -->
		<h5 class="font-h3-medium">选择合作对象</h5>
		<div class="mt-24">
			<span class="redStar yx-color-text-regular font-h4-regular mr-32">合作对象</span>
			<el-radio v-model="copartner" label="1" class="mr-32">达人</el-radio>
			<el-radio :disabled="isDisable" v-model="copartner" label="2">
				团长
				<span v-if="isDisable">(敬请期待)</span>
			</el-radio>
		</div>
		<p class="mt-12 flex-row-align-center" v-if="!isDr">
			<i class="fz-12 el-icon-info yx-color-text-secondary mr-4"></i>
			<span class="fz-12 yx-color-text-regular">
				关联达人为非必选项，不选则视为给该团长寄样，合作进度中不展示达人信息。团长关联的达人信息在“二级团长-合作团长列表-团长详情”中管理
			</span>
		</p>
		<div class="mt-12">
			<base-table :columns="columns" :options="{ rowKey: 'id' }" :list="list" class="partnerTable table-small"></base-table>
		</div>
		<div class="footer pb-12 pl-16 pt-12">
			<el-button type="text" @click="addTalent" v-if="isDr" :disabled="isAbled" :class="{ btnGray: isAbled }">+添加合作达人</el-button>
			<el-button type="text" @click="addTz" v-else :disabled="isAbled" :class="{ btnGray: isAbled }">+添加合作团长</el-button>
			<span class="yx-color-text-secondary ml-4 font-h4-regular">(已选 {{ selectedNum }}/{{ allNum }})</span>
		</div>
		<!-- 添加合作达人 -->
		<ChooseCooAnthorDrawer ref="CooAnthorDrawer" @getDrList="getDrList($event)" :platformId="platformId"></ChooseCooAnthorDrawer>
		<!-- 添加合作团长 -->
		<ChooseCooColonelDrawer ref="CooColonelDrawer" @getTzList="getTzList($event)" :platformId="platformId"></ChooseCooColonelDrawer>
	</div>
</template>
<script>
import { talentColumns, tzColumns } from './columns';
import { PLATFORM_DY } from '@/utils/dataMap';
export default {
	name: 'ChooseCooPartner',
	data() {
		return {
			talentColumns, //达人配置项
			tzColumns, //团长配置项
			copartner: '1', //默认为达人
			drList: [], //达人列表
			tzList: [], //团长列表
			teamIdObj: {},
		};
	},
	components: {
		// BaseTable: () => import('@/components/BaseTable'),
		ChooseCooColonelDrawer: () => import('../chooseCooColonelDrawer'),
		ChooseCooAnthorDrawer: () => import('../chooseCooAnthorDrawer'),
	},
	props: {
		platformId: {
			type: [Number, String],
			default: PLATFORM_DY.value,
		},
		isCommander: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		copartner(val) {
			this.tzList = [];
			this.drList = [];
			this.teamIdObj = {};
			this.$refs.CooAnthorDrawer.reset();
		},
		drList: {
			handler: function (val) {
				let isChecked = false;
				if (val && val.length) {
					isChecked = val.every(item => item.isChecked);
				}
				let anchorList = val?.map(item => {
					const {
						province,
						city,
						area,
						delivery_addr: deliveryAddr,
						delivery_name: deliveryName,
						delivery_mobile: deliveryMobile,
						code,
						delivery_id,
					} = item.form;
					const { team_institution_id: contactId, id: anchorId, anchor_name: anchorName } = item;
					return {
						contactId,
						anchorId: anchorId || 0,
						anchorName,
						province,
						city,
						area,
						code,
						deliveryAddr,
						deliveryName,
						deliveryMobile,
						addressId: delivery_id,
					};
				});
				let obj = {
					retailType: 0,
					anchorList,
					isChecked,
				};
				this.$emit('getList', obj);
			},
			deep: true,
		},
		tzList: {
			handler: function (val) {
				let isChecked = false;
				if (val && val.length) {
					isChecked = val.every(item => item.isChecked);
				}
				let anchorList = val?.map(item => {
					const {
						province,
						city,
						area,
						delivery_addr: deliveryAddr,
						delivery_name: deliveryName,
						delivery_mobile: deliveryMobile,
						code,
						delivery_id,
					} = item.form;
					const { team_institution_id: teamInstitutionId, anchor_id: anchorId, anchor_name: anchorName } = item;
					return {
						teamInstitutionId,
						anchorId: anchorId || 0,
						anchorName,
						province,
						city,
						area,
						code,
						deliveryAddr,
						deliveryName,
						deliveryMobile,
						addressId: delivery_id,
					};
				});
				let obj = {
					retailType: 1,
					anchorList,
					isChecked,
				};
				this.$emit('getList', obj);
			},
			deep: true,
		},
	},
	computed: {
		isDisable({ isCommander }) {
			return this.$isSp() || isCommander;
		},
		disabledDesc({ isCommander }) {
			return isCommander ? '选中的商品中含有“二级团长商品”，无法给团长批量寄样' : '';
		},
		//选择合作达人列表配置还是团长列表配置
		columns() {
			return this.isDr ? this.talentColumns : this.tzColumns;
		},
		//判断是否是添加达人
		isDr() {
			return this.copartner === '1';
		},
		isTz() {
			return this.copartner === '2';
		},
		list() {
			return this.isDr ? this.drList : this.tzList;
		},
		//已选数量
		selectedNum() {
			return this.drList?.length || this.tzList?.length || 0;
		},
		//全部的数量
		allNum() {
			return this.isDr ? 20 : 20;
		},
		//按钮是否禁用
		isAbled() {
			return this.allNum == this.selectedNum;
		},
	},
	mounted() {
		this.$Bus.$on('drSelectChange', (val, rowId, nickName) => {
			this.drList.forEach(item => {
				if (item.id == rowId) {
					item.team_institution_id = val || '';
					this.teamIdObj[rowId] = val;
					item.nickName = nickName || '';
				}
			});
		});
		this.$Bus.$on('resetTzId', rowId => {
			this.teamIdObj[rowId] = '';
		});
		this.$Bus.$on('saveAddress', addressObj => {
			this.drList.find(v => v.team_institution_id == addressObj.tzId);
		});
	},
	beforeDestroy() {
		this.$Bus.$off('drSelectChange');
		this.$Bus.$off('resetTzId');
	},
	methods: {
		//渲染达人
		getDrList(params) {
			//获取id的数组
			let list = [];
			list = params.map(item => ({
				...item,
				operation: this.getButtons(item.id),
				isDr: true,
				team_institution_id: this.teamIdObj[item.id],
				form: {},
				isChecked: false,
				isGetAddress: false,
				platformId: this.platformId,
			}));
			this.drList = this.drList.concat(list);
		},
		//渲染团长列表
		getTzList(params) {
			const _params = params.map(item => ({
				...item,
				operation: this.getButtons(item.id),
				isTz: true,
				team_institution_id: item.team_institution_id || '',
				form: {},
				isChecked: false,
				anchor_id: '',
				platformId: this.platformId,
			}));
			this.tzList.push(..._params);
		},
		//添加合作达人
		addTalent() {
			this.$refs.CooAnthorDrawer.show(this.drList);
		},
		//添加团长
		addTz() {
			this.$refs.CooColonelDrawer.show(this.tzList);
		},
		//从列表中删除数据
		delet(id) {
			const { tzList, drList } = this;
			if (this.isDr) {
				this.drList = drList.filter(item => item.id !== id);
				this.drList.forEach(item => {
					item.isGetAddress = false;
				});
			} else {
				this.tzList = tzList.filter(item => item.id !== id);
			}
			this.teamIdObj[id] = '';
			this.$Bus.$emit('sendContactOptions', this.drList);
		},
		getButtons(id) {
			let arr = [];
			arr.push({
				label: '删除',
				type: 'text',
				classtype: 3,
				click: () => {
					this.delet(id);
				},
			});
			return arr;
		},
		//清空相关数据
		reset() {
			this.drList = [];
			this.tzList = [];
			this.teamIdObj = {};
			this.copartner = 1;
		},
	},
};
</script>
<style lang="less" scoped>
.el-button {
	color: @color-primary;
	font-size: 14px;
}
.footer {
	border-bottom: 1px solid #f0f1f5;
}
/deep/ .el-radio__inner {
	border: 1px solid #c9cdd4 !important;
}
.partnerTable /deep/.el-button {
	font-size: 12px !important;
}

.btnGray {
	color: #c9cdd4;
}
</style>
